import * as Icons from "../assets/Icons";

function getModuleIcon(content) {
    switch (content) {
        case 'Na Direção da Segurança':
            return <Icons.IconDrivingHands />;
        case 'Escolhas e Consequências':
            return <Icons.IconStackOfBooks />;
        case 'Cuidar, Agir e Preservar':
            return <Icons.IconNaturePreservation />;
        case 'Placas, Cores e Caminhos':
            return <Icons.IconSignBoard />;
        default:
            return null;
    }
}

export default getModuleIcon;
